import { render } from "./Persona_AlergiaPers.vue?vue&type=template&id=f048b12e&scoped=true"
import script from "./Persona_AlergiaPers.vue?vue&type=script&lang=js"
export * from "./Persona_AlergiaPers.vue?vue&type=script&lang=js"

import "./Persona_AlergiaPers.vue?vue&type=style&index=0&id=f048b12e&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=f048b12e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f048b12e"]])

export default __exports__